import React from 'react';
import styled from 'styled-components';

const IndexBadge = styled.div`
  position: absolute;
  right: 16px;
  bottom: 8px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 11px;
  border-radius: 16px;
  padding: 2px 10px;
  z-index: 3;
`;

const MeetingItemWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  margin: 0 20px;
  padding: 15px;
  cursor: pointer;
`;

const MeetingImage = styled.img`
  width: 120px;
  height: 100px;
  border-radius: 0;
  object-fit: cover;
  flex-shrink: 0;
`;

const MeetingInfo = styled.div`
  margin-left: 12px;
  flex: 1;
  min-width: 0;
`;

const MeetingTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`;

const MeetingTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
`;

const MeetingTag = styled.span`
  background: #acacac;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  padding: 2px 4px;
  font-weight: 400;
  white-space: nowrap;
  display: inline-block;
  margin-left: 4px;
`;

const MeetingDescription = styled.div`
  font-size: 14px;
  color: #464646;
  margin-bottom: 10px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MeetingHashtags = styled.div`
  font-size: 13px;
  color: #bdbdbd;
  font-weight: 500;
  margin-top: 8px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MeetingItem = ({ image, title, tag, description, hashtags, index, total, onClick }) => (
  <MeetingItemWrapper onClick={onClick}>
    <MeetingImage src={image} alt={title} />
    <MeetingInfo>
      <MeetingTitleRow>
        <MeetingTitle>{title}</MeetingTitle>
        <MeetingTag>{tag}</MeetingTag>
      </MeetingTitleRow>
      <MeetingDescription>{description}</MeetingDescription>
      <MeetingHashtags>{hashtags}</MeetingHashtags>
    </MeetingInfo>
    {typeof index === 'number' && typeof total === 'number' && (
      <IndexBadge>{index} / {total}</IndexBadge>
    )}
  </MeetingItemWrapper>
);

export default MeetingItem; 